module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-300italic.705d8a7e4a4449671645c27716398853.woff2";